import clsx from "clsx";
import { FC, useCallback, useEffect, useRef, useState } from "react";
import * as Yup from 'yup';
import { useFormik } from "formik";
import Select from "react-select";
import Swal from "sweetalert2";
import { useDataTableStore } from "../../../stores/DataTableStore";
import axios from "axios";
import useAccessToken from "../../../hooks/AccessToken";
import useSWR, { mutate } from "swr";
import { Merchant } from "../../../interfaces/Merchant";
import { Source } from "../../../interfaces/Source";
import { ProductUnits } from "../../../interfaces/Product";
import { getListMerchantLinkPipeline, insertLead, saveMerchantLinkPipeline } from "../../../api/PipelineCRUD";
import moment from "moment";
import { nanoid } from "@reduxjs/toolkit";
import { Meeting } from "../../../interfaces/Meeting";
import { useSettingsStore } from "../../../stores/SettingsStore";
import { CustomField, CustomFieldSerialProps, SettingMultiPipelines } from "../../../interfaces/Settings";
import { insertMultiAttachment, insertAttachment } from "../../../api/ResourceAPI";
import { DatePicker } from "rsuite";
import { useChatStore } from "../../../stores/ChatStore";
import useUser from "../../../hooks/User";
import { AddMerchant } from "../../Merchants/AddMerchant";
import { KTSVG } from "../../../_metronic/helpers";
import { isBefore, isAfter, subDays, startOfToday } from 'date-fns';
import { currencyFormatter, calculateProductTotal, getDataById, handleCaps, isUUID, isValidUrl, unformatNumberInput, customThousandSeparatorDot, changeValueIfStringIntoNumber } from "../../../functions/general";
import { IPipeline, ListProduct, Pipeline } from "../../../interfaces/Pipeline";
import { useIntl } from "react-intl";
import { defaultScope } from "../../DataTable/UserScopeModal";
import useTodayRange from "../../../hooks/TodayRange";
import useHandleCloseModal from "../../../hooks/HandleCloseModal";
import { useCustomeStore } from "../../../stores/CustomeStore";
import { tailspin } from 'ldrs'
import { generateSerialApi } from "../../../api/Generals";
import { usePipelineStore } from "../../../stores/PipelineStore";
import { useMerchantStore } from "../../../stores/MerchantStore";
import { useUserStore } from "../../../stores/UserStore";
import { Subordinate } from "../../../interfaces/Subordinate";
import RenderCustomFieldGeneralForm, { CompanyCustomCFProps } from "../../RenderComponent/RenderCustomFieldGeneralForm";
import { useParams } from "react-router-dom";
import { SelectOption, SelectOptionGroup, SelectOptionMerchantLink } from "../../../interfaces/SelectOption";
import { CUSTOM_FIELD_NAME_MERCHANT_MASPION_SQUARE } from "../../../constant/General";
import { PipelineVirtualizedSelectOption } from "../../../app/pages/pipeline/MasterPipelinesContent";
import useClearInputByRef from "../../../hooks/useClearInputByRef";
import { useMeetingStore } from "../../../stores/MeetingsStore";
import { ChatPipeline } from "../../../interfaces/Chat/Chat";
import RenderMenuList from "../../RenderComponent/RenderMenuList";
import { checkIsCompanyElgisa, checkIsCompanyTanrise, isCustomCompanyPipeline } from "../../../functions/customCase";
import { Form } from "react-bootstrap";
import { useProductStore } from "../../../stores/ProductStore";
import ProductPipelineMain from "../ProductPipeline/ProductPipelineMain";
import useModalEffectResponsive from "../../../hooks/useModalEffectResponsive";
import ListProductPipeline from "../ProductPipeline/ListProductPipeline";
import useClearModalBackdropElement from "../../../hooks/useClearModalBackdropElement";
import { CustomSelectMerchantLinkOption, CustomSelectMerchantOption, CustomSelectMerchantOptionReqESB, CustomSelectSingleMerchantLinkValue } from "../CustomComponentSelect/CustomSelect";
import { CustomSelectSingleMerchantValue } from "../CustomComponentSelect/CustomSelect";
import { CustomSelectSingleMerchantValueReqESB } from "../CustomComponentSelect/CustomSelect";
import VirtualizedSelect from "../../Select/SelectVirtualized";
import { AccessLeadTemplate } from "../../../interfaces/AccessLeadTemplate";
import { getSelectedAccessLeadTemplate } from "../../../functions/leadTemplateAccess";

interface SelectOptionProduct extends SelectOption {
    sku?: string;
    note?: string;
    productUnits?: ProductUnits[];
    alias?: string;
    price?: number;
    vatPercentage?: number
}

interface AddPipelineProps {
    meeting?: Meeting
    merchantId?: string[]
    manageColumns?: any
    setManageColumns?: any
    setScope?: any
    showAddPipelineModal?: boolean
    handleResetFilter?: () => void,
    dateFilter?: {
        typeDateFilter: string
        startDate: Date | string
        endDate: Date | string
    }
    copyDataPipeline?: IPipeline
    setCopyDataPipeline?: (data: IPipeline | null) => void
}

const API_URL = process.env.REACT_APP_API_URL

const AddPipeline: FC<AddPipelineProps> = ({ meeting, merchantId, manageColumns, setManageColumns, setScope, showAddPipelineModal, handleResetFilter, dateFilter, copyDataPipeline, setCopyDataPipeline }) => {
    const todayRange = useTodayRange();
    tailspin.register()
    const { resetCustomFieldInputs } = useClearInputByRef()
    const modalRef = useRef<HTMLDivElement | null>(null);
    const closeModalRef = useRef<HTMLButtonElement>(null);
    const { tablesData, setTablesData, setFetchCounter, fetchCounter } = useDataTableStore()
    const { simplePipelines, setSelectMultiPipeline, multiPipelines, selectMultiPipeline } = usePipelineStore()
    const { merchants, simpleMerchants, simpleMerchantLoading, merchantLoading, setMerchants, setSimpleMerchants, setSimpleMerchantLoading, multiMerchants, setMultiMerchants } = useMerchantStore()
    const { simpleProducts, setTypeActionProduct, setProductTemp } = useProductStore()
    const { users, userSubordinateLoading, setUserSubordinateLoading, setUserSubordinates } = useUserStore()
    const token = useAccessToken()
    const [usersData, setUsersData] = useState<SelectOption[]>([]);
    const [merchantData, setMerchantData] = useState<SelectOptionGroup[]>([]);
    const [merchantChatData, setMerchantChatData] = useState<SelectOptionGroup[]>([]);
    const [optionTemplatePipeline, setOptionTemplatePipeline] = useState<SettingMultiPipelines[]>([]);
    const [optionMerchantLink, setOptionMerchantLink] = useState<SelectOptionMerchantLink[]>([]);
    const [selectMerchantLink, setSelectMerchantLink] = useState<SelectOptionMerchantLink>({} as SelectOptionMerchantLink);
    const { settings } = useSettingsStore()
    const [customFields, setCustomFields] = useState<CustomField>({})
    const [customFieldsMerchant, setCustomFieldsMerchant] = useState<any>([])
    const [selectTemplatePipeline, setSelectTemplatePipeline] = useState<string>('')
    const [dataCustomFieldSerial, setDataCustomFieldSerial] = useState<CustomFieldSerialProps>({});
    const [modalBtnLoading, setModalBtnLoading] = useState(false);
    const refArray = useRef<(HTMLInputElement | null)[]>([]);
    const user = useUser()
    const [showAddMerchantModal, setShowAddMerchantModal] = useState<boolean>(false);
    const [showModalAddProduct, setShowModalAddProduct] = useState<boolean>(false);
    const [listProducts, setListProducts] = useState<ListProduct[]>([]);
    const { simpleMeetings } = useMeetingStore()
    const { companyId } = useCustomeStore()
    const { templatePipelineId } = useParams()
    const [selectMerchantId, setSelectMerchantId] = useState<string>("")
    const [companyCFCustom, setCompanyCFCustom] = useState<CompanyCustomCFProps | null>(null);
    const intl = useIntl()
    const [hideFormProductBtn, setHideFormProductBtn] = useState<boolean>(false);
    const [dataLeadAccess, setDataLeadAccess] = useState<AccessLeadTemplate | null>(null)
    const [isLoadingLeadAccess, setIsLoadingLeadAccess] = useState<boolean>(false)

    useEffect(() => {
        if (user?.data?.company_id === companyId.maspionSquare) {
            if (settings.merchant_custom_fields) {
                setCustomFieldsMerchant(JSON.parse(settings.merchant_custom_fields))
            }
        }
    }, [settings])

    const fetcher = async (url: string) => {
        const response = await axios.get(url, {
            headers: {
                'X-Auth-token': token,
            },
        });
        return response.data.data;
    };

    const getUserURL = () => {
        if (user.data.permission_pipeline_read === "ALL" && settings.is_superadmin_allowed_as_pic) {
            return `${API_URL}user/company`
        } else if (user.data.permission_pipeline_read === "ALL") {
            return `${API_URL}users`
        } else {
            return `${API_URL}user/subordinates`
        }
    }

    const getAccessProductUrl = () => {
        if ((window.location.pathname.includes('/meetings/') || window.location.pathname === '/chat') && selectTemplatePipeline) {
            return true
        } else if (!window.location.pathname.includes('/meetings/') && window.location.pathname !== '/chat' && selectMultiPipeline?.id) {
            return true
        } else {
            return false
        }
    }

    const { data: userSubordinatesData = [], error: subordinatesError, isLoading: userSubordinatesLoading } = useSWR(getUserURL(), fetcher)
    const { data: merchantsData = [], error: merchantsError, isLoading: merchantsLoading } = useSWR(user.data.permission_merchant_read !== 'NONE' ? `${API_URL}merchants${templatePipelineId ? `?leadTemplateId=` + templatePipelineId : ""}` : null, fetcher)
    const { data: simpleMerchantsData = [], error: simpleMerchantsError, isLoading: simpleMerchantsLoading } = useSWR(`${API_URL}simple-merchants`, fetcher)
    const { data: multiMerchantsData = [], error: multiMerchantsError, isLoading: multiMerchantsLoading } = useSWR(`${API_URL}merchant-templates`, fetcher)
    const { data: merchantById = [], error: merchantByIdError, isLoading: merchantByIdLoading } = useSWR(selectMerchantId && user.data.company_id === companyId.maspionSquare ? `${API_URL}merchants/${selectMerchantId}` : null, fetcher)

    // untuk copy data pipeline
    useEffect(() => {
        if (copyDataPipeline && Object.keys(copyDataPipeline).length > 0) {
            setListProducts(copyDataPipeline.listProducts.map(product => ({
                ...product,
                leadProductDiscount: typeof product.leadProductDiscount === 'number' ? currencyFormatter(product.leadProductDiscount, true) : product.leadProductDiscount,
                leadProductPrice: typeof product.leadProductPrice === 'number' ? currencyFormatter(product.leadProductPrice, selectMultiPipeline?.currencyIsRounded) : product.leadProductPrice,
                leadProductTotal: calculateProductTotal(
                    product.leadProductQty,
                    Number(product.leadProductPrice),
                    Number(product?.leadProductDiscount ?? 0),
                    product.leadProductDiscountType || 'NOMINAL',
                    product.leadProductVatPercentage ?? 0,
                    selectMultiPipeline,
                    product.leadProductIsPriceIncludeVat ?? false
                )
            })))
        }
    }, [copyDataPipeline, selectMultiPipeline])

    const initialValues = {
        templatePipeline: (window.location.pathname.includes('/meetings/') || window.location.pathname === '/chat') ? selectTemplatePipeline : selectMultiPipeline?.id,
        pic: copyDataPipeline?.pic || '',
        labels: copyDataPipeline?.labels || '',
        startDate: copyDataPipeline?.startDate || '',
        merchantLink: '',
        merchant: copyDataPipeline?.merchant || '',
        source: copyDataPipeline?.source || '',
        note: copyDataPipeline?.note || '',
        ...Object.fromEntries(Object.keys(customFields).map((key) => {
            if (customFields[key].type === 'invoice_reminder') {
                return [
                    [`${key}_invoice_url`, null],
                    [`${key}_date_due`, null]
                ];
            } else if (copyDataPipeline?.customFields?.[key]) {
                const value = copyDataPipeline.customFields[key];
                if (customFields[key].type === 'date' && moment(value, ['YYYY-MM-DD', 'YYYY/MM/DD'], true).isValid()) {
                    return [key, value];
                } else if (customFields[key].type === 'number') {
                    return [key, customThousandSeparatorDot(value as unknown as number)];
                } else if (customFields[key].type === 'invoice_reminder') {
                    return [
                        [`${key}_invoice_url`, null],
                        [`${key}_date_due`, null]
                    ];
                } else {
                    return [key, value];
                }
            } else {
                return [key, null];
            }
        })),
    }

    if (dataLeadAccess?.leadSources.length === 1) initialValues.source = dataLeadAccess.leadSources[0].value
    if (user.data.permission_pipeline_create !== 'TEAM' && user.data.permission_pipeline_create !== 'ALL') initialValues.pic = user.data.name
    if (meeting) {
        initialValues.pic = meeting.owner_name
        initialValues.merchant = meeting.merchant_name
        initialValues.startDate = moment(meeting.date_meet).format('YYYY-MM-DD')
        initialValues.note = meeting.note
        if (meeting.date_meet) {
            initialValues.merchant = meeting.merchant_name
            initialValues.startDate = moment(meeting!.date_meet).format('YYYY-MM-DD')
        }
    }

    const formSchema = Object.keys(customFields).reduce((obj: any, item: string) => {
        const field = customFields[item];
        const isRequiredMessage = intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: field.name });
        const isValidUrlMessage = intl.formatMessage({ id: "FORM.VALIDATION.MUST_LINK" });

        if (field.type === 'multiple' || field.type === 'multipleOption' || field.type === 'images' || field.type === 'files' || field.type === 'videos' || field.type === 'merchant' || field.type === 'user' || field.type === 'meeting' || field.type === 'product') {
            obj[item] = field.required
                ? Yup.array().min(1, isRequiredMessage).required(isRequiredMessage).nullable()
                : Yup.array().notRequired().nullable();
        } else if (field.type === 'date') {
            obj[item] = field.required
                ? Yup.string().required(isRequiredMessage).nullable()
                : Yup.string().notRequired().nullable();
        } else if (field.type === 'link') {
            obj[item] = field.required
                ? Yup.string().nullable().required(isRequiredMessage).test('is-required', isValidUrlMessage, function (value) {
                    return !value || isValidUrl(value);
                })
                : Yup.string().nullable().test('is-required', isValidUrlMessage, function (value) {
                    return !value || isValidUrl(value);
                });
        } else if (field.type === 'serial') {
            obj[item] = Yup.array().notRequired().nullable();
        } else if (field.type === 'dateTimeRange') {
            if (field.required) {
                obj[item] = Yup.array().min(1, isRequiredMessage).required(isRequiredMessage).nullable();
            } else {
                obj[item] = Yup.array().notRequired().nullable();
            }
        } else if (field.type === 'email') {
            obj[item] = field.required
                ? Yup.string().email(intl.formatMessage({ id: "FORM.VALIDATION.EMAIL" })).required(isRequiredMessage).nullable()
                : Yup.string().email(intl.formatMessage({ id: "FORM.VALIDATION.EMAIL" })).notRequired().nullable();
        } else {
            obj[item] = field.required
                ? Yup.string().required(isRequiredMessage).nullable()
                : Yup.string().notRequired().nullable();
        }

        return obj;
    }, {});

    const validationSchema = Yup.object().shape({
        templatePipeline: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: "Database " + settings.pipeline_title })).nullable(),
        labels: settings.is_pipeline_label_required ? Yup.array().min(1, intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.LABELS" }) })).required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.LABELS" }) })) : Yup.array().notRequired(),
        pic: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.PIC" }) })).nullable(),
        startDate: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.DATE_STARTED" }) })).nullable(),
        merchant: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: settings.merchant_title })),
        source: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.MENU.SOURCES" }) })),
        note: (user.data.company_id === companyId.elgisa) ? Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: "Opportunity" })) : Yup.string().notRequired().nullable(),
        ...formSchema
    });

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            if (listProducts.length === 0 && !dataLeadAccess?.allowOptionalProducts) {
                Swal.fire({
                    icon: "error",
                    title: intl.formatMessage({ id: "FORM.VALIDATION.ADD_FIRST" }, { title: intl.formatMessage({ id: "FORM.MENU.PRODUCTS" }) }),
                    heightAuto: false,
                    target: document.getElementById('add-pipeline-modal'),
                    confirmButtonText: 'Ok'
                })

                return false
            }

            setSubmitting(true)
            setModalBtnLoading(true)

            const customFieldsValues: Record<string, string | string[] | number | null> = Object.keys(customFields).reduce(
                (obj, item) => ({
                    ...obj,
                    [item]: (values as Record<string, string | string[] | number | null>)[item],
                }),
                {}
            );

            const convertCustomFields: Record<string, any> = Object.keys(customFields).reduce(
                (obj, item) => {
                    if (!obj.info_custom_fields) {
                        obj.info_custom_fields = {};
                    }

                    if (customFields[item].type === 'merchant') {
                        const selectedMerchants = getDataById(values[item as keyof typeof values] as any, simpleMerchants);
                        obj[`custom_fields.${item}`] = selectedMerchants?.map((merchant: any) => merchant.name).join(", ");
                        obj.info_custom_fields[item] = selectedMerchants?.map((merchant: any) => ({
                            merchant_template_id: merchant.merchantTemplateId,
                            merchant_id: merchant.id,
                            merchant_name: merchant.name
                        })) || [];
                    }
                    else if (customFields[item].type === 'user') {
                        const selectedUsers = getDataById(values[item as keyof typeof values] as any, users);
                        obj[`custom_fields.${item}`] = selectedUsers?.map((user: any) => user.name).join(", ");
                        obj.info_custom_fields[item] = selectedUsers?.map((user: any) => ({
                            id: user.id,
                            name: user.name
                        })) || [];
                    }
                    else if (customFields[item].type === 'pipeline') {
                        const selectedPipeline = getDataById(values[item as keyof typeof values] as string, simplePipelines);
                        obj[`custom_fields.${item}`] = selectedPipeline ?
                            `${selectedPipeline.name} / ${selectedPipeline.nominal} / ${moment(selectedPipeline.dateCreated).format('DD MMM YYYY')}`
                            : '-';
                        obj.info_custom_fields[item] = selectedPipeline ? [{
                            id: selectedPipeline.id,
                            name: selectedPipeline.name,
                            nominal: selectedPipeline.nominal,
                            dateCreated: selectedPipeline.dateCreated
                        }] : [];
                    }
                    else if (customFields[item].type === 'meeting') {
                        const selectedMeeting: any[] = getDataById(values[item as keyof typeof values] as string, simpleMeetings);
                        obj[`custom_fields.${item}`] = selectedMeeting && selectedMeeting.length > 0 ?
                            selectedMeeting.map((meeting: any) => `${meeting.name} / ${moment(meeting.dateMeet).format('DD MMM YYYY')} / ${meeting.meetingStatus}`).join(', ')
                            : '-';
                        obj.info_custom_fields[item] = selectedMeeting && selectedMeeting.length > 0 ? selectedMeeting.map((meeting: any) => ({
                            meeting_template_id: meeting.meetingTemplateId,
                            id: meeting.id,
                            merchant_name: meeting.name,
                            date_meet: meeting.dateMeet,
                            meeting_status: meeting.meetingStatus
                        })) : [];
                    } else if (customFields[item].type === 'product') {
                        const selectedProducts = getDataById(values[item as keyof typeof values] as any, simpleProducts);
                        obj[`custom_fields.${item}`] = selectedProducts?.map((product: any) => product.name).join(", ");
                        obj.info_custom_fields[item] = selectedProducts?.map((product: any) => ({
                            product_id: product.id,
                            product_name: product.name,
                            product_prices: product.product_prices,
                        })) || [];
                    }
                    else {
                        obj[`custom_fields.${item}`] = values[item as keyof typeof values] || '';
                        obj.info_custom_fields[item] = [];
                    }

                    return obj;
                },
                {} as Record<string, any>
            );

            // Use Promise.all to await all async operations
            var countResourceError = 0
            await Promise.all(
                Object.keys(customFields).map(async (key) => {
                    if (customFields[key].type === 'image' || customFields[key].type === 'file' || customFields[key].type === 'video') {
                        try {
                            if (values[key as keyof typeof values] && typeof values[key as keyof typeof values] === 'object') {
                                const resourceResponse = await insertAttachment(values[key as keyof typeof values]!! as string | File, 'PIPELINE', token);
                                if (resourceResponse.data.success) customFieldsValues[key] = resourceResponse.data.data.length > 0 ? resourceResponse.data.data[0] : null;
                                else countResourceError++
                            }
                        } catch (error) {
                            countResourceError++
                        }
                    } else if (customFields[key].type === 'images' || customFields[key].type === 'files' || customFields[key].type === 'videos') {
                        try {
                            if (values[key as keyof typeof values]) {
                                let dataMultiAttachment = (values[key as keyof typeof values] as any).filter((item: any) => typeof item !== 'string')
                                let dataUrlAttachment = (values[key as keyof typeof values] as any).filter((item: any) => typeof item === 'string')

                                const resourceResponse = await insertMultiAttachment(dataMultiAttachment, 'PIPELINE', token);
                                if (resourceResponse.data.success) (customFieldsValues[key] as any) = resourceResponse.data.data.length > 0 ? [...dataUrlAttachment, ...resourceResponse.data.data] : dataUrlAttachment.length > 0 ? dataUrlAttachment : null;
                                else countResourceError++
                            }
                        } catch (error) {
                            countResourceError++
                        }
                    } else if (customFields[key].type === 'invoice_reminder') {
                        try {
                            const resourceResponse = await insertAttachment(values[key + "_invoice_url" as keyof typeof values], 'PIPELINE', token);
                            if (resourceResponse.data.success) customFieldsValues[key] = JSON.stringify({ date_due: values[key + "_date_due" as keyof typeof values], invoice_url: resourceResponse.data.data.length > 0 ? resourceResponse.data.data[0] : null })
                            else countResourceError++
                        } catch (error) {
                            countResourceError++
                        }
                    } else if (customFields[key].type === 'multiple' || customFields[key].type === 'multipleOption') {
                        var multipleValues = values[key as keyof typeof values]?.length! > 0 ? values[key as keyof typeof values] : null;
                        customFieldsValues[key] = multipleValues as string
                    } else if (customFields[key].type === 'dateTimeRange') {
                        if (values[key as keyof typeof values]) {
                            const [startDate, endDate] = values[key as keyof typeof values];
                            customFieldsValues[key] = [
                                startDate ? (new Date(startDate).toISOString() as any) : null,
                                endDate ? (new Date(endDate).toISOString() as any) : null
                            ];
                        } else {
                            customFieldsValues[key] = null;
                        }
                    } else if (customFields[key].type === 'serial') {
                        try {
                            if (dataCustomFieldSerial[key].value.length === 0) {
                                const serialResponse = await generateSerialApi(key, "Pipeline", token);
                                customFieldsValues[key] = serialResponse.data.success ? serialResponse.data.data : null;
                            } else {
                                customFieldsValues[key] = dataCustomFieldSerial[key].value
                            }
                        } catch (error) {
                            countResourceError++
                        }
                    } else if (customFields[key].type === 'number') {
                        const stringValue = values[key as keyof typeof values] as string;
                        customFieldsValues[key] = stringValue ? unformatNumberInput(stringValue) : null;
                    }
                })
            );

            if (countResourceError > 0) {
                Swal.fire({
                    icon: "error",
                    text: `${intl.formatMessage({ id: "FORM.VALIDATION.ADD_FAILED" })}.`,
                    heightAuto: false,
                    target: document.getElementById('add-pipeline-modal'),
                    confirmButtonText: 'Ok'
                })
                setModalBtnLoading(false);
                setSubmitting(false);
            } else {
                try {
                    const leadLabels = values.labels.length > 0 && Array.isArray(values.labels) ? values.labels.map((label: string) => { return { id: label, name: labelsOption.filter((option: any) => option.value === label)[0]['label'] } }) : []
                    const startDate = moment(values.startDate).utc(true).toISOString();
                    const response = await insertLead(
                        leadLabels,
                        values.templatePipeline,
                        isUUID(values.pic) ? values.pic : meeting ? meeting.owner_id : user.data.id,
                        meeting && !merchantId ? meeting.merchant_id : values.merchant,
                        startDate,
                        values.source,
                        listProducts.map((product) => {
                            return {
                                ...product,
                                leadProductHpp: product.leadProductHpp ? changeValueIfStringIntoNumber(product.leadProductHpp) : null,
                                leadProductPrice: changeValueIfStringIntoNumber(product.leadProductPrice),
                                leadProductTotal: changeValueIfStringIntoNumber(product.leadProductTotal),
                                leadProductDiscount: changeValueIfStringIntoNumber(product.leadProductDiscount as string | number)
                            }
                        }),
                        token,
                        values.note === '' ? undefined : values.note,
                        meeting ? meeting.id : undefined,
                        customFieldsValues,
                        isCustomCompanyPipeline('wolacom', user, companyId, selectMultiPipeline) ? true : undefined
                    );
                    if (response.data.success) {
                        Swal.fire({
                            icon: "success",
                            title: intl.formatMessage({ id: "ALERT.TITLE.SUCCESS" }),
                            text: `${intl.formatMessage({ id: "FORM.VALIDATION.ADD_SUCCESS" })}.`,
                            heightAuto: false,
                        })
                        resetCustomFieldInputs()
                        closeModalRef.current?.click()

                        if (meeting) {
                            setTablesData('meetings', (tablesData.meetings?.map(data => {
                                if (data.id === meeting.id) {
                                    return {
                                        ...data,
                                        meeting_is_pipeline: true,
                                    }
                                } else {
                                    return data
                                }
                            })));
                        }

                        let merchantLinkResult = null
                        if (values.merchantLink) {
                            merchantLinkResult = await Promise.resolve(handleSaveMerchantLink(response.data.data.id));
                        }

                        response.data.data.lead_logs_count = 0
                        mutate(`${API_URL}chat/merchants-leads`)
                        if (window.location.pathname === '/chat') {
                            const { setListChatRooms, phoneNumber } = useChatStore.getState();
                            let newPipeline: ChatPipeline = {
                                id: response.data.data.id,
                                merchant: {
                                    id: response.data.data.merchant_id,
                                    name: response.data.data.merchant_name,
                                    phone: response.data.data.merchant_phone
                                },
                                PIC: {
                                    id: response.data.data.owner_id,
                                    name: response.data.data.owner_name
                                },
                                template: {
                                    id: response.data.data.lead_template_id,
                                    name: response.data.data.lead_template_name
                                },
                                nominal: {
                                    withVAT: response.data.data.nominal,
                                    withoutVAT: response.data.data.nominal_without_vat
                                },
                                age: Number(response.data.data.lead_age),
                                progress: {
                                    id: response.data.data.lead_progress_id,
                                    name: response.data.data.lead_progress_name,
                                    type: response.data.data.lead_progress_progress_type,
                                    color: ""
                                },
                                customFields: response.data.data.custom_fields
                            }

                            setListChatRooms((prevMessages) => ({
                                ...prevMessages,
                                [phoneNumber]: {
                                    ...prevMessages[phoneNumber],
                                    pipelines: [...prevMessages[phoneNumber].pipelines, newPipeline]
                                }
                            }))

                            const getPipelineURL = () => {
                                if (user.data.is_superadmin) {
                                    return `${API_URL}leads?scope=all&merchant_phone=${phoneNumber.split('-')[0]}`
                                } else {
                                    return `${API_URL}leads?scope=${defaultScope(user.data.permission_pipeline_read)}&user_id=${user.data.id}&merchant_phone=${phoneNumber.split('-')[0]}`
                                }
                            }

                            const getMerchantURL = () => {
                                if (user.data.is_superadmin) {
                                    return `${API_URL}merchants?scope=all&phone=${phoneNumber.split('-')[0]}`
                                } else {
                                    return `${API_URL}merchants?scope=${defaultScope(user.data.permission_merchant_read)}&user_id=${user.data.id}&phone=${phoneNumber.split('-')[0]}`
                                }
                            }

                            mutate(getPipelineURL())
                            mutate(getMerchantURL())
                        }
                        const newProgress = checkIsCompanyTanrise(companyId, user) ? intl.formatMessage({ id: "FORM.LABEL.CONTACTED" }) : intl.formatMessage({ id: "FORM.LABEL.NEW" })
                        setTablesData('pipelines', ([{
                            ...response.data.data,
                            ...convertCustomFields['custom_fields'],
                            info_custom_fields: convertCustomFields.info_custom_fields,
                            customFields: customFieldsValues,
                            nominalWithoutVatForSearch: response.data.data.nominal_without_vat ? Math.round(response.data.data.nominal_without_vat as number).toString() : null,
                            nominalForSearch: response.data.data.nominal ? Math.round(response.data.data.nominal as number).toString() : null,
                            merchant_link: merchantLinkResult,
                            date_last_update: moment(response.data.data.updatedAt).utc(true).format('YYYY-MM-DD HH:mm:ss'),
                            lead_progress_name: response.data.data.lead_progress_name === "NEW" ? newProgress : response.data.data.lead_progress_name,
                            leadProducts: response.data.data.leadProducts?.map((product: ListProduct) => { //nambahin data yg gaada di response
                                const objProduct = { ...product }
                                const dataProductById = listProducts.filter((p) => p.productId === product.productId);
                                const dataProductByUnit = listProducts.filter((p) => product.leadProductUnitId && p.unitId === product.leadProductUnitId);
                                if (dataProductById.length > 0) {
                                    objProduct.productSku = dataProductById[0]?.productSku
                                    objProduct.productNote = dataProductById[0]?.productNote
                                }
                                if (dataProductByUnit.length > 0) {
                                    objProduct.unitId = dataProductByUnit[0]?.unitId
                                    objProduct.unitName = dataProductByUnit[0]?.unitName
                                    objProduct.productUnits = dataProductByUnit[0]?.productUnits
                                } else {
                                    objProduct.productUnits = []
                                }
                                return objProduct
                            }),
                            productsAndUnits: response.data.data.leadProducts.map((product: any) => {
                                return `${product.productName} ${product.unitName ? `(${product.unitName})` : '(PCS)'}`;
                            })
                        }, ...tablesData.pipelines]))
                        handleResetFilter!()
                        // setFetchCounter(fetchCounter + 1)
                        // setScope(user.data.permission_pipeline_read === 'OWNED' || user.data.permission_pipeline_read === 'ALL' ? defaultScope(user.data.permission_pipeline_read) : UserScope.WholeTeam)
                        setCompanyCFCustom(null)
                        formik.resetForm()
                        setCopyDataPipeline?.(null)
                    }
                } catch (error: any) {
                    console.log(error, 'error')
                    Swal.fire({
                        icon: 'error',
                        title: error?.response?.data?.message || "Gagal menambahkan data",
                        target: document.getElementById('add-pipeline-modal'),
                        confirmButtonText: 'Ok'
                    })
                } finally {
                    setSubmitting(false)
                    setModalBtnLoading(false)
                }
            }
        }
    });


    const { data: labels = [], error: labelsError, isLoading: labelsLoading } = useSWR(`${API_URL}labels?usableBy[]=pipeline`, fetcher)

    useEffect(() => {
        if (formik.values.merchant) {
            setSelectMerchantId(formik.values.merchant)
        }
    }, [formik.values.merchant])

    const [labelsOption, setLabelOption] = useState([])

    useEffect(() => {
        const newLabelsOption = labels.map((label: any) => { return { value: label.id, label: label.name } })
        setLabelOption(newLabelsOption)
    }, [labels])

    useEffect(() => {
        // Get the modal element
        const modalElement = modalRef.current;

        // Define the event listener
        const handleModalHidden = () => {
            if (!showAddMerchantModal) {
                formik.resetForm()
                setCopyDataPipeline?.(null)
                setOptionMerchantLink([])
                setSelectMerchantLink({} as SelectOptionMerchantLink)
                setListProducts([])
                setSelectTemplatePipeline("")
                setMerchantChatData([])
                Object.keys(customFields).forEach((key, index) => {
                    // Reset 
                    const ref = refArray.current[index];
                    if (ref && ref.value) {
                        ref.value = "";
                    }

                    if (customFields[key].type === "multiple") {
                        var checkboxes = document.getElementsByName(key)
                        checkboxes.forEach((checkbox: any) => {
                            checkbox.checked = false
                        })
                    }
                    if (customFields[key].type === "date") {
                        formik.setFieldValue(key, null)
                    }
                });
            }
        };

        // Attach the event listener
        modalElement?.addEventListener('hidden.bs.modal', handleModalHidden);

        // Cleanup
        return () => {
            modalElement?.removeEventListener('hidden.bs.modal', handleModalHidden);
        };
    }, [formik, showAddMerchantModal, setShowAddMerchantModal]);

    const updateUserSubordinates = useCallback(() => {
        setUserSubordinateLoading(userSubordinatesLoading);
        if (!userSubordinatesLoading) {
            const data = userSubordinatesData.map((subordinate: Subordinate) => ({
                value: subordinate.id,
                label: subordinate.name
            }));

            if (user.data.permission_pipeline_read !== "ALL") {
                data.unshift({ value: user.data.id, label: user.data.name })
            }

            setUsersData(data)
            setUserSubordinates(userSubordinatesData)
        }
    }, [userSubordinatesData, userSubordinatesLoading]);

    useEffect(() => {
        updateUserSubordinates();
    }, [updateUserSubordinates]);

    const updateMerchants = useCallback(() => {
        if (!merchantsLoading && merchantsData.length > 0) {
            setTimeout(() => {
                setMerchants(merchantsData)
            }, 100)
        }
    }, [merchantsData, merchantsLoading]);

    useEffect(() => {
        updateMerchants();
    }, [updateMerchants]);

    useEffect(() => {
        if (!multiMerchantsLoading) {
            setMultiMerchants(multiMerchantsData)
        }
    }, [multiMerchantsLoading]);

    const updateSimpleMerchants = useCallback(() => {
        setSimpleMerchantLoading(simpleMerchantsLoading)
        if (!simpleMerchantsLoading) {
            setSimpleMerchants(simpleMerchantsData)
        }
    }, [simpleMerchantsData, simpleMerchantsLoading]);

    useEffect(() => {
        updateSimpleMerchants();
    }, [updateSimpleMerchants]);

    useEffect(() => {
        setTimeout(() => {
            const groupMerchant: { label: string, id: string, leadTemplates: { id: string, name: string }[], options: SelectOptionProduct[] }[] = multiMerchants.map((group) => {
                return {
                    label: group.name,
                    id: group.id,
                    leadTemplates: group.leadTemplates.map((template) => ({ id: template.id, name: template.name })),
                    options: [] as SelectOptionProduct[]
                }
            })

            if (!merchantLoading && !merchantId && user.data.permission_merchant_read !== "NONE") {
                merchants.forEach((merchant) => {
                    var customFieldValueCompanyCode = simpleMerchants.find((data: Merchant) => data.id === merchant!.id)

                    const isEsbCompany = user.data.company_id === companyId.esb
                    const index = groupMerchant.findIndex((group) => group.id === merchant.merchantTemplateId)
                    index !== -1 && groupMerchant[index].options.push({
                        ...merchant,
                        value: merchant.id,
                        label: `${merchant.name} / ${merchant.phone} ${(isEsbCompany && customFieldValueCompanyCode?.customFieldCompanyCode) ? `/ ${customFieldValueCompanyCode?.customFieldCompanyCode}` : ""}`
                    })
                })
                setMerchantData(groupMerchant)
            }
            else if (!merchantLoading && merchantId && user.data.permission_merchant_read !== "NONE") {
                const merchantData = merchants?.filter((merchant: Merchant) => merchantId.includes(merchant.id))
                merchantData.forEach((merchant) => {
                    var customFieldValueCompanyCode = simpleMerchants.find((data: Merchant) => data.id === merchant!.id)

                    const isEsbCompany = user.data.company_id === companyId.esb
                    const index = groupMerchant.findIndex((group) => group.id === merchant.merchantTemplateId)
                    index !== -1 && groupMerchant[index].options.push({
                        ...merchant,
                        value: merchant.id,
                        label: `${merchant.name} / ${merchant.phone} ${(isEsbCompany && customFieldValueCompanyCode?.customFieldCompanyCode) ? `/ ${customFieldValueCompanyCode?.customFieldCompanyCode}` : ""}`
                    })
                })

                const resultTemplatePipeline = multiPipelines.filter((data) =>
                    groupMerchant
                        // .filter((merchant) => merchant.options.length > 0)
                        .flatMap((merchant) => merchant.leadTemplates?.map((template) => template.id) || [])
                        .filter((value, index, self) => self.indexOf(value) === index) // remove duplicate ids
                        .includes(data.id)
                );

                setOptionTemplatePipeline(resultTemplatePipeline)
                setMerchantData(groupMerchant)
            }
        }, 0)
    }, [merchants, merchantId, multiMerchants, simpleMerchants])

    useEffect(() => {
        if (selectTemplatePipeline && merchantId && merchantData.length > 0) {
            const filteredMerchants = merchantData.filter((data) => {
                const hasSelectedTemplate = data.leadTemplates?.some(
                    (template) => template.id === selectTemplatePipeline
                );
                return data.options.length > 0 && hasSelectedTemplate;
            });

            setMerchantChatData(filteredMerchants);
        }
    }, [selectTemplatePipeline, merchantData])

    useEffect(() => {
        if (selectTemplatePipeline || templatePipelineId) {
            setIsLoadingLeadAccess(true)
            getSelectedAccessLeadTemplate(selectTemplatePipeline || templatePipelineId!, token, setDataLeadAccess)
            setIsLoadingLeadAccess(false)
        } else {
            setDataLeadAccess(null)
        }
    }, [selectTemplatePipeline, templatePipelineId, token])

    useEffect(() => {
        if (selectMultiPipeline && Object.keys(selectMultiPipeline).length !== 0) {
            var data = selectMultiPipeline.customFields
            const transformedData = Object.keys(data).reduce((acc: any, key: string) => {
                acc[key] = {
                    loading: false,
                    value: []
                };
                return acc;
            }, {});

            setCustomFields(data)
            setDataCustomFieldSerial(transformedData)
        }
    }, [selectMultiPipeline])

    const doubleCheckIsCompanyElgisa = () => {
        if (checkIsCompanyElgisa(companyId, user) && hideFormProductBtn === true) {
            return true
        } else {
            return false
        }
    }

    useEffect(() => {
        if (checkIsCompanyElgisa(companyId, user)) {
            if (listProducts.length > 0) {
                setHideFormProductBtn(true)
            } else {
                setHideFormProductBtn(false)
            }
        }

        doubleCheckIsCompanyElgisa()
    }, [listProducts, setListProducts])

    useModalEffectResponsive({
        modalIdPrimary: 'add-pipeline-modal',
        modalIdSecondary: 'add-merchant-modal',
        showModalSeconday: showAddMerchantModal,
        setShowModalSecondary: setShowAddMerchantModal
    })

    useModalEffectResponsive({
        modalIdPrimary: 'add-pipeline-modal',
        modalIdSecondary: 'modal-add-product-pipeline',
        showModalSeconday: showModalAddProduct,
        setShowModalSecondary: setShowModalAddProduct
    })

    useEffect(() => {
        if (formik.values.templatePipeline) {
            setCustomFields(multiPipelines.find((pipeline: SettingMultiPipelines) => pipeline.id === formik.values.templatePipeline)!.customFields)
        }
    }, [formik.values.templatePipeline])

    const addMerchant = (merchant: Merchant) => {
        setMerchants([...merchants, merchant])
        formik.setFieldValue("merchant", merchant.id)
    }

    const handleGenerateSerial = async (key: string) => {
        setDataCustomFieldSerial(prevState => ({
            ...prevState,
            [key]: { ...prevState[key], loading: true }
        }));

        try {
            const response = await generateSerialApi(key, "Pipeline", token);
            if (response.data.success) {
                formik.setFieldValue(key, response.data.data)
                setDataCustomFieldSerial(prevState => ({
                    ...prevState,
                    [key]: { ...prevState[key], value: response.data.data }
                }));
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok',
                target: document.getElementById('add-pipeline-modal'),
                heightAuto: false,
            })
        } finally {
            setDataCustomFieldSerial(prevState => ({
                ...prevState,
                [key]: { ...prevState[key], loading: false }
            }));
        }
    }

    const handleChangeMerchant = async (option: PipelineVirtualizedSelectOption) => {
        formik.handleChange({
            target: {
                name: "merchant",
                value: (option?.value || "")
            }
        })

        formik.handleChange({
            target: {
                name: "merchantLink",
                value: ""
            }
        })

        setSelectMerchantLink({} as SelectOptionMerchantLink)

        if (option === null) return

        try {
            var res = await getListMerchantLinkPipeline(option.value, token)
            if (res.data.success) {
                var listOption = res.data.data.merchantTemplateDestinationData.map((item: any) => ({
                    label: item.nameCustomField + " / " + item.templateName + " / " + item.merchantName,
                    value: item.idCustomField + "_" + item.templateId + "_" + item.merchantId,
                    nameCustomField: item.nameCustomField,
                    idCustomField: item.idCustomField,
                    nameMerchant: item.merchantName,
                    nameTemplate: item.templateName,
                    idTemplate: item.templateId,
                    idMerchant: item.merchantId,
                    idMerchantLink: res.data.data.id
                }))

                setOptionMerchantLink(listOption)
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok',
                target: document.getElementById('add-pipeline-modal'),
                heightAuto: false
            })
        }
    }

    const handleSaveMerchantLink = async (leadId: string) => {
        try {
            var res = await saveMerchantLinkPipeline(leadId, selectMerchantLink?.idMerchant!, selectMerchantLink?.idMerchantLink!, token)
            if (res.data.success) {
                return res.data.data
            }
        } catch (error: any) {
            console.log(error.response.data.message)
        }
    }

    const isDisabledBtnAddProduct = () => {
        if ((window.location.pathname.includes('/meetings/') || window.location.pathname === '/chat')) {
            if (selectTemplatePipeline) return false
            else return true
        }

        return false
    }

    const { handleCloseModal } = useHandleCloseModal(modalRef, closeModalRef, formik);

    useClearModalBackdropElement({ showModal: showModalAddProduct })
    useClearModalBackdropElement({ showModal: showAddMerchantModal })

    return (
        <>
            <div className={`modal fade ${showAddMerchantModal || showModalAddProduct ? 'hide' : 'show'}`} tabIndex={-1} id="add-pipeline-modal" ref={modalRef}>
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "1250px" }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{intl.formatMessage({ id: "FORM.ACTION.ADD" })} {!meeting && !window.location.pathname.includes('/chat') ? selectMultiPipeline?.name : settings.pipeline_title}</h5>
                            <div
                                className="btn btn-active-light-primary btn-icon btn-sm ms-2"
                                onClick={handleCloseModal}
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                        <form onSubmit={formik.handleSubmit} noValidate>
                            <div className="modal-body">
                                {formik.status && (
                                    <div className='alert alert-danger mb-lg-15'>
                                        <div className='alert-text font-weight-bold'>{formik.status}</div>
                                    </div>
                                )}
                                {/* Template Pipeline */}
                                {
                                    (window.location.pathname.includes('/meetings/') || window.location.pathname === '/chat') &&
                                    <div className="input-group mb-3">
                                        <label className='form-label text-dark fs-6 fw-bolder required'>Database {settings.pipeline_title}</label>
                                        <VirtualizedSelect
                                            className={clsx("w-100")}
                                            options={window.location.pathname === '/chat' ? optionTemplatePipeline : multiPipelines}
                                            placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} Database ${settings.pipeline_title}`}
                                            value={(window.location.pathname === '/chat' ? optionTemplatePipeline : multiPipelines).find(option => option.value === formik.values.templatePipeline) || null}
                                            onChange={(option) => {
                                                formik.handleChange({
                                                    target: {
                                                        name: "templatePipeline",
                                                        value: option?.value || ""
                                                    }
                                                })

                                                if (multiPipelines && option?.value) setSelectMultiPipeline(multiPipelines.find(item => item.id === option?.value)!)
                                                setSelectTemplatePipeline(option?.value || "")
                                                setListProducts([])
                                                mutate(`${API_URL}lead-template-product-accesses/${option?.value}`)
                                            }}
                                            onBlur={
                                                () => formik.values.templatePipeline === "" && formik.setFieldTouched("templatePipeline", true)
                                            }
                                        />
                                        {formik.touched.templatePipeline && formik.errors.templatePipeline && (
                                            <div className='text-danger fv-plugins-message-container'>
                                                <span role='alert' className="text-danger">{formik.errors.templatePipeline}</span>
                                            </div>
                                        )}
                                    </div>
                                }

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        {/* Users */}
                                        <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: "FORM.LABEL.PIC" })}</label>
                                        <div className="input-group mb-3">
                                            {
                                                meeting || (user.data.permission_pipeline_create !== 'TEAM' && user.data.permission_pipeline_create !== 'ALL') ?
                                                    <div className="input-group mb-3">
                                                        <input
                                                            {...formik.getFieldProps('pic')}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            className={clsx(
                                                                'form-control form-control-lg',
                                                                { 'is-invalid': formik.touched.pic && formik.errors.pic },
                                                            )}
                                                            type='text'
                                                            name='pic'
                                                            autoComplete='off'
                                                            onInput={(e) => handleCaps(e)}
                                                            disabled
                                                        />
                                                    </div>
                                                    :
                                                    <VirtualizedSelect
                                                        className="w-100"
                                                        options={usersData}
                                                        placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.PIC" })}`}
                                                        value={usersData.find(option => option.value === formik.values.pic) || null}
                                                        onChange={
                                                            option => formik.handleChange({
                                                                target: {
                                                                    name: "pic",
                                                                    value: option?.value || ""
                                                                }
                                                            })
                                                        }
                                                        onBlur={
                                                            () => formik.values.pic === "" && formik.setFieldTouched("pic", true)
                                                        }
                                                        isDisabled={userSubordinateLoading}
                                                        isReselectable={true}
                                                    />
                                            }
                                        </div>
                                        {formik.touched.pic && formik.errors.pic && (
                                            <div className='fv-plugins-message-container text-danger'>
                                                <span role='alert' className="text-danger">{formik.errors.pic}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        {/* startDate */}
                                        <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: "FORM.LABEL.DATE_STARTED" })}</label>
                                        <div className="input-group mb-3">
                                            {
                                                settings.pipeline_date_min && settings.pipeline_date_min === "1" ?
                                                    <DatePicker
                                                        ranges={todayRange}
                                                        editable={false}
                                                        format="dd MMM yyyy HH:mm"
                                                        value={formik.values.startDate ? new Date(formik.values.startDate) : null}
                                                        defaultValue={null}
                                                        style={{ width: "100%", zIndex: 0 }}
                                                        container={document.querySelector('#add-pipeline-modal') as HTMLElement}
                                                        onChange={(value: any) => {
                                                            if (value) formik.setFieldValue('startDate', moment(value).format('YYYY-MM-DD HH:mm'))
                                                            else formik.setFieldValue('startDate', null)
                                                        }}
                                                        shouldDisableDate={date => isBefore(date, subDays(startOfToday(), 1)) || isAfter(date, new Date())}
                                                    />
                                                    :
                                                    <DatePicker
                                                        ranges={todayRange}
                                                        editable={false}
                                                        format="dd MMM yyyy HH:mm"
                                                        value={formik.values.startDate ? new Date(formik.values.startDate) : null}
                                                        defaultValue={null}
                                                        style={{ width: "100%", zIndex: 0 }}
                                                        container={document.querySelector('#add-pipeline-modal') as HTMLElement}
                                                        onChange={(value: any) => {
                                                            if (value) formik.setFieldValue('startDate', moment(value).format('YYYY-MM-DD HH:mm'))
                                                            else formik.setFieldValue('startDate', null)
                                                        }}
                                                    />
                                            }
                                        </div>
                                        {formik.touched.startDate && formik.errors.startDate && (
                                            <div className='fv-plugins-message-container text-danger'>
                                                <span role='alert' className="text-danger">{formik.errors.startDate}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className={`col-12 ${user.data.company_id !== companyId.esb && selectMultiPipeline?.isFeatureLabelEnabled ? 'col-md-6' : ''}`}>
                                        {/* Sources */}
                                        <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: "FORM.MENU.SOURCES" })}</label>
                                        <div className="input-group mb-3">
                                            <Select
                                                key={
                                                    window.location.pathname === '/chat' ? nanoid() : ''
                                                }
                                                isClearable
                                                options={dataLeadAccess?.leadSources ?? []}
                                                placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.MENU.SOURCES" })}`}
                                                value={dataLeadAccess?.leadSources.find(option => option.value === formik.values.source) || null}
                                                onChange={
                                                    option => formik.handleChange({
                                                        target: {
                                                            name: "source",
                                                            value: option?.value || ""
                                                        }
                                                    })
                                                }
                                                onBlur={
                                                    () => formik.values.source === "" && formik.setFieldTouched("source", true)
                                                }
                                                className="w-100"
                                                isDisabled={isLoadingLeadAccess}
                                            />
                                        </div>
                                        {formik.touched.source && formik.errors.source && (
                                            <div className='fv-plugins-message-container text-danger'>
                                                <span role='alert' className="text-danger">{formik.errors.source}</span>
                                            </div>
                                        )}
                                    </div>
                                    {/* label */}
                                    {
                                        user.data.company_id !== companyId.esb && selectMultiPipeline?.isFeatureLabelEnabled &&
                                        <div className="col-12 col-md-6">
                                            <label className={`form-label fs-6 fw-bolder text-dark ${settings.is_pipeline_label_required ? 'required' : ''}`}>{intl.formatMessage({ id: 'FORM.LABEL.LABELS' })}</label>
                                            <div className="input-group mb-3">
                                                <Select
                                                    closeMenuOnSelect={false}
                                                    openMenuOnClick
                                                    isMulti
                                                    options={labelsOption}
                                                    placeholder={`${intl.formatMessage({ id: 'FORM.ACTION.CHOOSE' })} ${intl.formatMessage({ id: 'FORM.LABEL.LABELS' })}`}
                                                    value={labelsOption && Array.isArray(labelsOption)
                                                        ? labelsOption.filter((option: any) =>
                                                            formik.values.labels.includes(option.value)
                                                        )
                                                        : []}
                                                    onChange={(selectedOptions) => {
                                                        const selectedValues = selectedOptions
                                                            ? selectedOptions.map((option: any) => option.value)
                                                            : []
                                                        formik.setFieldValue('labels', selectedValues)
                                                    }}
                                                    className='w-100'
                                                    onBlur={() =>
                                                        formik.values.labels === '' &&
                                                        formik.setFieldTouched('labels', true)
                                                    }
                                                />
                                            </div>
                                            {formik.touched.labels && formik.errors.labels && (
                                                <div className='fv-plugins-message-container text-danger'>
                                                    <span role='alert' className="text-danger">{formik.errors.labels}</span>
                                                </div>
                                            )}
                                        </div>
                                    }
                                </div>



                                {/* Merchants */}
                                <label className='form-label text-dark fs-6 fw-bolder required'>{settings.merchant_title}</label>
                                <div className="">
                                    {
                                        !meeting && !merchantId ?
                                            <div className="row mb-3">
                                                <VirtualizedSelect
                                                    title={settings.merchant_title}
                                                    // key={
                                                    //     window.location.pathname === '/chat' ? 'pipe-merchant-chat' : 'pipe-merchant'
                                                    // }
                                                    options={merchantData}
                                                    isLoading={merchantLoading || simpleMerchantLoading}
                                                    isDisabled={merchantLoading || simpleMerchantLoading}
                                                    className={clsx("col-10")}
                                                    placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${settings.merchant_title}`}
                                                    value={merchantData.map(merchanttemplate => merchanttemplate.options).flat().find((option) => option.value === formik.values.merchant) || null}
                                                    onChange={(option: PipelineVirtualizedSelectOption) => { handleChangeMerchant(option) }}
                                                    onBlur={
                                                        () => formik.values.merchant === "" && formik.setFieldTouched("merchant", true)
                                                    }
                                                    components={
                                                        {
                                                            Option: user.data.company_id === companyId.esb ? (props) => CustomSelectMerchantOptionReqESB({ user, companyId, simpleMerchants, ...props }) : (props) => CustomSelectMerchantOption({ user, companyId, merchants: merchants, ...props }),
                                                            SingleValue: user.data.company_id === companyId.esb ? (props) => CustomSelectSingleMerchantValueReqESB({ user, companyId, simpleMerchants, ...props }) : (props) => CustomSelectSingleMerchantValue({ user, companyId, merchants: merchants, ...props }),
                                                        }
                                                    }
                                                    isReselectable={true}
                                                />
                                                <button type="button" className="btn btn-secondary col-2 btn-sm" onClick={() => {
                                                    setShowAddMerchantModal(true);
                                                }}>
                                                    <i className="fa-plus fas"></i>
                                                </button>
                                            </div>
                                            :
                                            merchantId &&
                                            <div className="mb-3">
                                                <VirtualizedSelect
                                                    title={settings.merchant_title}
                                                    options={merchantChatData}
                                                    isLoading={merchantLoading || simpleMerchantLoading}
                                                    isDisabled={merchantLoading || simpleMerchantLoading}
                                                    className={clsx("col-12")}
                                                    placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${settings.merchant_title}`}
                                                    value={merchantChatData.map(merchanttemplate => merchanttemplate.options).flat().find((option) => option.value === formik.values.merchant) || null}
                                                    onChange={(option: PipelineVirtualizedSelectOption) => { handleChangeMerchant(option) }}
                                                    onBlur={
                                                        () => formik.values.merchant === "" && formik.setFieldTouched("merchant", true)
                                                    }
                                                    components={
                                                        {
                                                            Option: user.data.company_id === companyId.esb ? (props) => CustomSelectMerchantOptionReqESB({ user, companyId, simpleMerchants, ...props }) : (props) => CustomSelectMerchantOption({ user, companyId, merchants: merchants, ...props }),
                                                            SingleValue: user.data.company_id === companyId.esb ? (props) => CustomSelectSingleMerchantValueReqESB({ user, companyId, simpleMerchants, ...props }) : (props) => CustomSelectSingleMerchantValue({ user, companyId, merchants: merchants, ...props }),
                                                        }
                                                    }
                                                    isReselectable={true}
                                                />
                                            </div>
                                    }
                                </div>
                                {formik.touched.merchant && formik.errors.merchant && (
                                    <div className='text-danger fv-plugins-message-container'>
                                        <span role='alert' className="text-danger">{formik.errors.merchant}</span>
                                    </div>
                                )}

                                {
                                    optionMerchantLink.length > 0 &&
                                    <div className="mb-3">
                                        <VirtualizedSelect
                                            title={settings.merchant_title}
                                            options={optionMerchantLink}
                                            isDisabled={merchantLoading}
                                            className={clsx("col-10")}
                                            placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${settings.merchant_title} Link`}
                                            value={optionMerchantLink.find(data => data.value === formik.values.merchantLink) || null}
                                            onChange={(option: PipelineVirtualizedSelectOption) => {
                                                setSelectMerchantLink(option)
                                                formik.handleChange({
                                                    target: {
                                                        name: "merchantLink",
                                                        value: (option?.value || "")
                                                    }
                                                })
                                            }}
                                            components={
                                                {
                                                    Option: (props) => CustomSelectMerchantLinkOption({ user, companyId, ...props }),
                                                    SingleValue: (props) => CustomSelectSingleMerchantLinkValue({ user, companyId, ...props }),
                                                }
                                            }
                                            isLoading={merchantLoading}
                                            isReselectable={true}
                                        />

                                    </div>
                                }

                                {/* Detail Select Merchant */}
                                {formik.values.merchant && merchantById && user.data.company_id === companyId.maspionSquare && (
                                    <div className="mb-5">
                                        <div
                                            className="d-flex align-items-center cursor-pointer mb-3"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#merchantDetails"
                                            role="button"
                                            aria-expanded="true"
                                            aria-controls="merchantDetails"
                                        >
                                            <i className="fa-chevron-right fas fs-6 me-2 toggle-icon"></i>
                                            <span className="fw-bold">{intl.formatMessage({ id: "FORM.LABEL.DETAILS" }, { title: settings.merchant_title })} </span>
                                        </div>

                                        <div className="collapse show" id="merchantDetails">
                                            <ul className="list-unstyled ms-4">
                                                {Object.keys(customFieldsMerchant || {}).map((key) => {
                                                    if (CUSTOM_FIELD_NAME_MERCHANT_MASPION_SQUARE.includes(customFieldsMerchant[key].name)) {
                                                        return (
                                                            <li key={key} className="d-flex align-items-center mb-3">
                                                                <span className="fw-bold" style={{ width: "200px" }}>{customFieldsMerchant[key].name}</span>
                                                                <span className="mx-2">:</span>
                                                                <span>
                                                                    {merchantById.customFields && merchantById.customFields[key] ?
                                                                        merchantById.customFields[key]
                                                                        :
                                                                        <span className="text-muted fst-italic">-</span>
                                                                    }
                                                                </span>
                                                            </li>
                                                        )
                                                    }
                                                    return null;
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                )}

                                <div className="separator separator-dashed my-10"></div>
                                {
                                    doubleCheckIsCompanyElgisa() ? <></> : (
                                        <button type="button" className="btn btn-primary w-100" disabled={isDisabledBtnAddProduct()} onClick={() => {
                                            setShowModalAddProduct(true)
                                            setTypeActionProduct('add')
                                            setProductTemp({} as ListProduct)
                                        }}>
                                            <i className="fas fa-plus me-2"></i> {intl.formatMessage({ id: "FORM.ACTION.ADD_PRODUCT" })}
                                        </button>
                                    )
                                }
                                <ListProductPipeline listProducts={listProducts} setListProducts={setListProducts} setShowModalAddProduct={setShowModalAddProduct} />
                                <div className="separator separator-dashed my-10"></div>

                                {/* Note */}
                                {
                                    (user.data.company_id === companyId.elgisa) ?
                                        <label className='form-label text-dark fs-6 fw-bolder required'>Opportunity</label>
                                        :
                                        <label className={`form-label fs-6 fw-bolder text-dark`}>{intl.formatMessage({ id: "FORM.LABEL.NOTE" })}</label>
                                }
                                <div className="input-group mb-3">
                                    <textarea
                                        id="floatingTextarea"
                                        {...formik.getFieldProps('note')}
                                        className={clsx(
                                            'form-control form-control-lg',
                                            { 'is-invalid': formik.touched.note && formik.errors.note },
                                        )}
                                        style={{ zIndex: 0 }}
                                        name="note"
                                        onInput={(e) => handleCaps(e)}
                                    >
                                    </textarea>
                                </div>
                                {formik.touched.note && formik.errors.note && (
                                    <div className='text-danger fv-plugins-message-container'>
                                        <span role='alert' className="text-danger">{formik.errors.note}</span>
                                    </div>
                                )}
                                {/* ------------------------ Wolacom ------------------------ */}
                                {isCustomCompanyPipeline('wolacom', user, companyId, (window.location.pathname.includes('/meetings/') || window.location.pathname === '/chat') ? formik.values.templatePipeline : selectMultiPipeline) && (
                                    <div className="my-4">
                                        {/* {selectMultiPipeline.id} {selectMultiPipeline.name} */}
                                        <Form.Check
                                            type={'checkbox'}
                                            id={`wolacom-checkbox`}
                                            label={`${intl.formatMessage({ id: "FORM.PIPELINE.SAME_ADDRESS" }, { title: settings.merchant_title })}`}
                                            onChange={(e) => {
                                                const wolacom_cf_keys = process.env.NODE_ENV === 'development'
                                                    ?
                                                    [
                                                        '46827b7c-080b-4038-a5e1-188f55ff0b7d', // nama penerima
                                                        '23caf632-6f6b-49d2-9037-682f6ac900e8', // nomor penerima
                                                        '5fb84507-360b-4651-a121-82aa8ff2c5c4'  // alamat penerima
                                                    ]
                                                    :
                                                    [
                                                        '8a0dc33c-30d0-4d7b-bd81-b155f08be97f', // nama penerima
                                                        'c1b2a220-bc73-4bd2-9c6e-f1dc67fa7f85', // nomor penerima
                                                        'bb057e9e-a3af-40d4-bd08-a9ff16cc47c8'  // alamat penerima
                                                    ]

                                                const updatedCustomFields = { ...customFields };

                                                for (const key in updatedCustomFields) {
                                                    if (wolacom_cf_keys.includes(key)) {
                                                        updatedCustomFields[key] = {
                                                            ...updatedCustomFields[key],
                                                            required: !e.target.checked
                                                        };
                                                    }
                                                }
                                                setCustomFields(updatedCustomFields);
                                                setCompanyCFCustom(prevState => ({
                                                    ...prevState,
                                                    wolacom: {
                                                        text: {
                                                            cf_keys: wolacom_cf_keys,
                                                            disabled: e.target.checked,
                                                            required: !e.target.checked,
                                                            value: ''
                                                        },
                                                    },
                                                }));

                                                setTimeout(() => {
                                                    e.target.checked && wolacom_cf_keys.forEach(key => {
                                                        formik.setFieldValue(key, '');
                                                        // formik.setFieldTouched(key, true);
                                                        // formik.setErrors({});
                                                        formik.validateForm();
                                                    });
                                                }, 200); // tunggu 2 microdetik
                                            }}
                                        />
                                    </div>
                                )}
                                {/* ------------------------ ----- ------------------------ */}
                                {customFields &&
                                    <RenderCustomFieldGeneralForm
                                        customFieldGeneral={customFields}
                                        formik={formik}
                                        errors={formik.errors}
                                        containerRef={document.querySelector('#add-pipeline-modal') as HTMLElement}
                                        dataCustomFieldSerial={dataCustomFieldSerial}
                                        handleGenerateSerial={handleGenerateSerial}
                                        typeTemplateCustomField='pipeline'
                                        MenuList={RenderMenuList}
                                        typeAction="add"
                                        companyCustom={companyCFCustom ? companyCFCustom : null}
                                    />
                                }
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="d-none btn btn-light"
                                    data-bs-dismiss="modal"
                                    ref={closeModalRef}
                                >
                                    {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={handleCloseModal}
                                >
                                    {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                                </button>
                                <button type="button" onClick={() => formik.handleSubmit()} className={`btn btn-primary me-10 ${(modalBtnLoading) ? "disabled" : ""}`} data-kt-indicator={modalBtnLoading ? 'on' : 'off'}>
                                    <span className="indicator-label">
                                        {intl.formatMessage({ id: "FORM.ACTION.ADD" })}
                                    </span>
                                    <span className="indicator-progress">
                                        Loading... <span className="align-middle ms-2 spinner-border spinner-border-sm"></span>
                                    </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {
                showAddMerchantModal && <AddMerchant addMerchant={addMerchant} />
            }

            {
                showModalAddProduct &&
                <ProductPipelineMain
                    products={getAccessProductUrl() ? dataLeadAccess?.leadProducts ?? [] : []}
                    completeProducts={dataLeadAccess?.completeLeadProducts ?? []}
                    productLoading={isLoadingLeadAccess}
                    listProducts={listProducts}
                    setListProducts={setListProducts}
                />
            }
        </>
    )
}

export { AddPipeline }